import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

export function setupRoot(): void {
  applicationModuleRegistry.register({
    entry: 'results-portal-root',
    id: 'results-portal-root',
    name: 'results-portal-root',
    route: APPLICATION_ROUTES.RESULTS_PORTAL_ROOT
  });
}